/**
 * Website (marketing) captcha configuration — build-time / env driven, so the
 * public site renders the Cloudflare Turnstile widget WITHOUT a runtime call to
 * the backend (`/api/auth/captcha-config`). The Turnstile site key is public by
 * design (it ships in the page HTML), so there is no reason to fetch it from the
 * API — this keeps the website decoupled from the application backend.
 *
 * The form submit still sends the captcha token to the backend, which verifies
 * it with its secret. Only the *rendering* is decoupled.
 *
 * Env vars (set at build time):
 *   REACT_APP_TURNSTILE_SITE_KEY   the public Cloudflare Turnstile site key
 *   REACT_APP_CAPTCHA_PROVIDER     optional, defaults to "TURNSTILE"
 */
export const websiteCaptchaConfig = () => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';
  return {
    provider: process.env.REACT_APP_CAPTCHA_PROVIDER || 'TURNSTILE',
    siteKey,
    enabled: !!siteKey,
  };
};

/** Documentation URL (opens in a new window from the website). */
export const docsUrl = () =>
  process.env.REACT_APP_DOCS_URL || 'https://verops.io/docs';
